export default __webpack_public_path__ + "static/media/Hunger.edcf9a55.jpg";